import {Block, Button} from "../../components/";
import styles from "../../components/Block/Block.module.scss";
import cn from "classnames";

const text = "Выполни четыре задания, которые приведут к заветным лутбоксам от 2х2 и Звука, а самого везучего к суперпризу — консоли PS5!";

export const FirstBlock = ({handler}) => {
    return (
        <Block name="box-blue-12" title="Что нужно сделать" desc={text}>
            <div className={cn(styles.desc, styles.order_1)}>Пройди онлайн-квест и выиграй сверхзвуковые призы<br/>от 2х2 и HiFi-стриминга Звук!</div>
            <Button text="Дайте шума!" handler={handler}/>
        </Block>
    )
}